
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL_MEEP;
export const API_EXTERNAL_URL = process.env.REACT_APP_API_EXTERNAL_URL_MEEP;
export const API_PAYMENTS_URL = process.env.REACT_APP_API_PAYMENT_URL;
export const API_TAB_SPLIT_BOT_URL = process.env.REACT_APP_API_TAB_SPLIT_BOT_URL;
export const API_ERP_URL = process.env.REACT_APP_API_ERP_URL;
// export const API_BASE_URL = "http://192.168.32.18/Promptus.Meep.Server";
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

export const getUserImageUrl = (id: string) => `${IMAGE_URL}usuarios-profile/${id}.png`;